// These are the one trust grouping categories defined by oneTrust
export const enum ONE_TRUST_COOKIE_CATEGORIES {
  STRICTLY_NECESSARY = 'C0001',
  PERFORMANCE = 'C0002',
  FUNCTIONAL = 'C0003',
  TARGETING = 'C0004',
  SOCIAL = 'C0005',
}

export const oneTrustCookieConfiguration: {
  serviceName: string;
  cookieNamesToRemove: string[];
  targetDomains?: string[];
  oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES;
}[] = [
  // STRICTLY_NECESSARY (C0001)
  {
    serviceName: 'Auth tokens',
    cookieNamesToRemove: ['way-auth-token', 'site-auth'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.STRICTLY_NECESSARY,
  },
  {
    serviceName: 'Client Identifier (cid)',
    cookieNamesToRemove: ['cid'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.STRICTLY_NECESSARY,
  },
  {
    serviceName: 'Org Preferences (Stripe)',
    cookieNamesToRemove: ['_stripe_org_props'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.STRICTLY_NECESSARY,
  },
  {
    serviceName: 'Session ID',
    cookieNamesToRemove: ['m:'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.STRICTLY_NECESSARY,
  },
  {
    serviceName: 'Stripe',
    cookieNamesToRemove: [
      '__stripe_mid',
      '__stripe_sid',
      'stripe.csrf',
      'merchant',
    ],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.STRICTLY_NECESSARY,
  },

  // PERFORMANCE (C0002)
  {
    serviceName: 'Adobe Analytics',
    cookieNamesToRemove: [
      's_cc',
      's_sq',
      's_vi',
      's_fid',
      's_ecid',
      's_ac',
      'AMCV_*',
      'AMCVS_*',
    ],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.PERFORMANCE,
  },
  {
    serviceName: 'Google Analytics',
    cookieNamesToRemove: ['_ga*', '_ga_8G51NM1DLN'],
    targetDomains: ['.storage.googleapis.com'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.PERFORMANCE,
  },
  {
    serviceName: 'Google Tag Manager',
    cookieNamesToRemove: ['_gcl_au*', '_gcl_UA*'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.PERFORMANCE,
  },
  {
    serviceName: 'PostHog',
    cookieNamesToRemove: ['ph_phc_*'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.PERFORMANCE,
  },
  {
    serviceName: 'Tealium Analytics',
    cookieNamesToRemove: ['utag_*'],
    oneTrustCategory: ONE_TRUST_COOKIE_CATEGORIES.PERFORMANCE,
  },
];
